class StickyProductAdd extends HTMLElement {
    constructor() {
        super();
  
        this.selectors = {
            productForm: "product-form .product-form__buttons",
            sectionHeader: "#shopify-section-header",
            stickyHeaderHiddenClass: "shopify-section-header-hidden",
            openClass: "open"
        }
  
        this.scrollElementToCheck = document.querySelector(this.selectors.productForm);
        this.sectionHeader = document.querySelector(this.selectors.sectionHeader);
        this.sectionHeaderHeight = this.sectionHeader.offsetHeight;
        this.stickyAddToCartMoved = false;
        if (!this.scrollElementToCheck) {
            return;
        }
  
        setTimeout(() => {this.bindEvents()}, 500);
  
        window.addEventListener("resize", () => {
            this.scrollElementToCheck = document.querySelector(this.selectors.productForm);
            this.sectionHeader = document.querySelector(this.selectors.sectionHeader);
            this.sectionHeaderHeight = this.sectionHeader.offsetHeight;
  
            this.resetTranstionProperyIfSet();
        });
    }
  
    bindEvents() {
        var self = this;
        window.addEventListener("scroll", function() {
            if (window.scrollY > (self.scrollElementToCheck.offsetTop + self.scrollElementToCheck.offsetHeight + 200)) {
                if (self.isOpen() && !self.isHeaderOpen()) {
                    self.resetTranstionProperyIfSet();
  
                    return;
                };
  
                // if we have sticky bar and sticky header we move the sticky bar Y pixels down to match header
                if (self.isOpen() && self.isHeaderOpen() && !self.stickyAddToCartMoved) {
                    // self.style.transform = `translateY(${self.sectionHeaderHeight-1}px)`;
                    self.stickyAddToCartMoved = true;
  
                    return;
                };
  
                self.open();
            } else {
                self.resetTranstionProperyIfSet();
  
                if (!self.isOpen()) return;
  
                self.close();
            }
  
        });
      this.bindRadioAndDropdownEvents();
    }
  
    bindRadioAndDropdownEvents() {
      const radioInputs = document.querySelectorAll('input[type=radio]');
      const sizeDropdown = document.getElementById('size-selector');
      const variantIdInputSelector = document.querySelector("#sticky-add-to-cart input[name=id]")
      const variantIdInput = document.querySelector("#sticky-add-to-cart input[name=id]").value;
  
          console.log(radioInputs, "radioInputs");
          console.log(sizeDropdown, "sizeDropdown");
      console.log(variantIdInput, "variantIdInput");
  
      const updateURL = (variantId) => {
          if (variantId) {
              let currentURL = new URL(window.location.href);
              currentURL.searchParams.set('variant', variantId);
              history.replaceState({}, '', currentURL);
          }
      };
  
      sizeDropdown.addEventListener('change', (e) => {
          const selectedOption = e.target.value;
  
        if (variantIdInput) {
            variantIdInputSelector.value = selectedOption.toString();
        }
          updateURL(selectedOption);

          const productForms = document.querySelectorAll(`.main_product_form`);

            productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            const select = productForm.querySelector('select[name="id"]');
            input.value = selectedOption;
            console.log(selectedOption)
            // if(select) {
            //     select.value = this.currentVariant.id;
            // }
           
            });

      });
      document.getElementById('size-selector').addEventListener('change', function() {
        // Get the selected option and its data_option1 and data_option2 values
        var selectedOption = this.options[this.selectedIndex];
        var dataOption1Value = selectedOption.getAttribute('data_option1');
        var dataOption2Value = selectedOption.getAttribute('data_option2');

        // Find all the containers for variant radios
        var containers = document.querySelectorAll('variant-radios .product-form__input.option2 .product-form__options-container');

        containers.forEach(function(container) {
            // Find radio inputs inside the current container
            var radioInputs = container.querySelectorAll('input[type="radio"]');
    
            radioInputs.forEach(function(radioInput) {
            // Check if radio value matches either data_option1 or data_option2
            if (radioInput.value === dataOption1Value ) {
                radioInput.checked = true;  // Check the matching radio input
            } else {
                radioInput.checked = false; // Uncheck others if needed
                    }
                    });
                }); 
                
                var containers = document.querySelectorAll('variant-radios .product-form__input.option3 .product-form__options-container');

                containers.forEach(function(container) {
                    // Find radio inputs inside the current container
                    var radioInputs = container.querySelectorAll('input[type="radio"]');
            
                    radioInputs.forEach(function(radioInput) {
                    // Check if radio value matches either data_option1 or data_option2
                    if (radioInput.value === dataOption2Value ) {
                        radioInput.checked = true;  // Check the matching radio input
                    } else {
                        radioInput.checked = false; // Uncheck others if needed
                            }
                            });
                        });
                    
      });
  
      document.addEventListener('DOMContentLoaded', function() {
    const labels = document.querySelectorAll('.product-form__options-container label');
    
    labels.forEach(label => {
      label.addEventListener('click', function() {
        console.log('Label clicked');
      });
    });
  });
  }
  
    resetTranstionProperyIfSet() {
        if (this.stickyAddToCartMoved) {
            // this.style.removeProperty('transform');
            this.stickyAddToCartMoved = false;
        }
    }
  
    isHeaderOpen() {
        return !this.sectionHeader.classList.contains(this.selectors.stickyHeaderHiddenClass)
    }
  
    isOpen() {
        return this.classList.contains(this.selectors.openClass);
    }
  
    open() {
        document.body.classList.add('sticky-add-open')
        this.classList.add(this.selectors.openClass);
    }
  
    close() {
        document.body.classList.remove('sticky-add-open')
        this.classList.remove(this.selectors.openClass);
    }
  }
  
  customElements.define('sticky-product-add', StickyProductAdd);
  
  
  